export default "__VITE_ASSET__C8mpjAY9__"